import { ArithmeticOperation } from '@suntex.fim/enums';

/**
 * returns games object based on operation
 */
export function getVifGames(operation: ArithmeticOperation) {
  switch (operation) {
    case ArithmeticOperation.Addition:
      return {
        vif_add_rules: 'Zero Rule Game',
        vif_add_rules_1: 'One Rule',
        vif_add_rules_2: 'Mirror Rule',
        vif_add: '64 Facts',
        vif_add_redo: 'Undo 2 to 10',
        vif_add_rules_dd: '100 Facts',
        vif_add_rules_dd_1: 'Adding Tens',
        vif_add_redo_1: 'Undo 11 to 99',
        vif_add_1: '10K Facts',
      };
    case ArithmeticOperation.Subtraction:
      return {
        vif_sub_rules: 'Zero Rule',
        vif_sub_rules_1: 'One Rule',
        vif_sub_rules_2: 'Loose Mirror Rule',
        vif_sub: '64 Facts',
        vif_sub_redo: 'Undo 11 to 18',
        vif_sub_rules_dd: '100 Facts',
        vif_sub_rules_dd_1: 'Subtracting Tens',
        vif_sub_redo_1: 'Undo 21 to 99 Into Tens And Ones',
        vif_sub_1: 'Subtract Double Digits, Easy Case',
        vif_sub_redo_2: 'Undo 21 to 98 Into Tens And Teens',
        vif_sub_2: '10K Facts',
      };
    case ArithmeticOperation.Multiplication:
      return {
        vif_mul_rules: 'Zero And One Rule',
        vif_mul_rules_1: 'Mirror Rule',
        vif_mul_rules_dd: 'Auditory Memory (Part 1)',
        vif_mul_rules_dd_1: 'Auditory Memory (Part 2)',
        vif_mul_rules_dd_2: '36 Facts',
        vif_mul: '100 Facts',
        vif_mul_rules_dd_3: 'Multiplying Tens by Ones',
        vif_mul_rules_dd_4: 'Multiply Double Digits by Single Digits',
        vif_mul_rules_dd_5: 'Multiplying Tens by Tens',
        vif_mul_1: '10K Facts',
      };
    case ArithmeticOperation.Division:
      return {
        vif_div_rules: 'Zero and One Rule',
        vif_div_rules_1: 'Loose Mirror Rule',
        vif_div_rules_dd: '36 Facts',
        vif_div: '100 Facts',
        vif_div_rules_dd_1: 'Multiplying Single Digits by Tens',
        vif_div_rules_dd_2: 'Dividing Triple Digits by Single Digits',
        vif_div_rules_dd_3: 'Multiplying Double Digits by Tens',
        vif_div_1: '10K Facts',
      };
    default:
      return {};
  }
}
